import { useQuery, useSuspenseQuery } from '@tanstack/react-query';
import { useGraphneAPI } from '@nexelem/graphne-api';

const GRAPHNE_RESOURCE_GROUP_LIST_KEY = 'graphne-resources-group-list';

export const useGraphneResourcesGroupList = () => {
  const api = useGraphneAPI();

  return useQuery({
    queryKey: [GRAPHNE_RESOURCE_GROUP_LIST_KEY],
    queryFn: () => api.getGraphneResourcesGroupList(),
  });
};

export const useGraphneResourcesGroupListSuspense = () => {
  const api = useGraphneAPI();

  return useSuspenseQuery({
    queryKey: [GRAPHNE_RESOURCE_GROUP_LIST_KEY],
    queryFn: () => api.getGraphneResourcesGroupList(),
  });
};
